<template>
  <vs-popup class=""
            id="popup"
            title="CREATE SUPPLIER USER"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="title" name="title" rules="required" v-slot="{ errors }">
                <small class="label">Title</small>
                <v-select :clearable="false" placeholder="" v-model="createForm.title" :reduce="option => option" :options="['Mr.','Mrs.','Miss']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="first_name" name="first_name" rules="required" v-slot="{ errors }">
                <small class="label">First Name</small>
                <vs-input v-model="createForm.first_name"   name="first_name" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col  md:w-full w-full md:mb-0">
              <ValidationProvider vid="last_name" name="last_name" rules="required" v-slot="{ errors }">
                <small class="label">Last Name</small>
                <vs-input  v-model="createForm.last_name" class="w-full"  name="last_name" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="email" name="email" rules="required|email" v-slot="{ errors }">
                <small class="label">Email</small>
                <vs-input v-model="createForm.email"   name="email" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-1/2">
              <ValidationProvider vid="site_telephone" name="site_telephone" rules="" v-slot="{ errors }">
                <small class="label">Country Code</small>
                <v-select :filter-by="myFilter" :clearable="false" placeholder="code" label="isd_code" v-model="createForm.country_code_telephone" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.isd_code}} - {{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/2">
              <ValidationProvider vid="telephone" name="telephone" rules="tel|min_tel|max_tel" v-slot="{ errors }">
                <small class="label">Telephone</small>
                <vs-input  v-model="createForm.telephone" class="w-full"  name="telephone" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-1/2">
              <ValidationProvider vid="country_code_mobile" name="country_code_mobile" rules="" v-slot="{ errors }">
                <small class="label">Country Code</small>
                <v-select :filter-by="myFilter" :clearable="false" placeholder="code" label="isd_code" v-model="createForm.country_code_mobile" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.isd_code}} - {{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/2">
              <ValidationProvider vid="mobile" name="mobile" rules="tel|min_tel|max_tel" v-slot="{ errors }">
                <small class="label">Mobile</small>
                <vs-input  v-model="createForm.mobile" class="w-full"  name="mobile" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="role" name="role" rules="required" v-slot="{ errors }">
                <small class="label">Supplier Portal Role</small>
                <v-select :clearable="false" placeholder="" v-model="createForm.role_id" :reduce="option => option.id" 
                  :options="role_list" 
                  :dir="$vs.rtl ? 'rtl' : 'ltr'" label="name"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="role" name="role" rules="required" v-slot="{ errors }">
                <small class="label">Nimble User Role</small>
                <v-select :clearable="false" placeholder="" v-model="createForm.types"
                  :options="customer_user_types" multiple  :reduce="option => option.value"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'" label="name"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierRepository = RepositoryFactory.get('supplier')
  const DropDownRepository = RepositoryFactory.get('drop_down')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  import { mapActions, mapGetters } from 'vuex'
  
  function initialState() {
    return {
      open: false,
      id: '',
      media: '',
      isImage: '',
      isVideo: '',
      title :'',
      nodata: false,
      isNote:'',
      note:'',
      createForm: {},
      countryCodes: [],
      supplierId: null,
      role_list: []
    }
  }

export default {
  name: 'CreateSupplierUserPopUp',
  data () {
    return initialState()
  },
  methods:{
    ...mapActions(['fetchCustomerUserTypes']),
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.supplierId = id
        await this.loadCountrCode()
        await this.fetchSupplierRoles()
        await this.fetchCustomerUserTypes()
        this.open = true;
      } catch (error) {

      }
    },


    async onClickCreateStaffUser () {
      const vue = this;
      this.$vs.loading()
       try {
        this.createForm.supplier_id = this.supplierId
         await SupplierRepository.createSupplierUser(this.createForm)
         this.showSuccessMessage('New supplier user created successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async fetchSupplierRoles() {
      try {
        const { data } = (await DropDownRepository.getSupplierRoleList()).data
        this.role_list = data
      } catch (error) {
        
      }
    },
    async loadCountrCode() {
      this.$vs.loading()
      const {data} =  (await SupplierManufactureRepository.getCountryCodes()).data
      this.countryCodes =  data
      this.$vs.loading.close()
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
  },
  async mounted () {

  },
  computed: {
    ...mapGetters(['customer_user_types'])
  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 50%;
  }


</style>
